import { BreadCrumb } from 'primereact/breadcrumb';
import { Button } from 'primereact/button';
import { CanView } from 'components/Can';
import { DataSource } from 'components/DataSource';
import { FilterTags } from 'components/FilterTags';
import { InputText } from 'primereact/inputtext';
import { Link } from 'react-router-dom';
import { Menubar } from 'primereact/menubar';
import { MultiSelect } from 'primereact/multiselect';
import { PageRequestError } from 'components/PageRequestError';
import { Paginator } from 'primereact/paginator';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';
import useApp from 'hooks/useApp';
import useAuth from 'hooks/useAuth';

import useListPage from 'hooks/useListPage';
const OperatorsListPage = (props) => {
		const auth = useAuth();
	const app = useApp();
	const filterSchema = {
		search: {
			tagTitle: "Search",
			value: '',
			valueType: 'single',
			options: [],
		},
		status_operator: {
			tagTitle: "Stato",
			value: [],
			valueType: 'multiple',
			options: [],
		},
		user_role_id: {
			tagTitle: "Ruolo",
			value: [],
			valueType: 'multiple',
			options: [],
		}
	}
	const pageController = useListPage(props, filterSchema);
	const filterController = pageController.filterController;
	const { records, pageReady, loading, selectedItems, apiRequestError, getPageBreadCrumbs, deleteItem, pagination } = pageController;
	const { filters, setFilterValue, setFilterOptions } = filterController;
	const { totalRecords, totalPages, recordsPosition, firstRow, limit, onPageChange } =  pagination;
	function ActionButton(data){
		const items = [
		{
			label: "View",
			command: (event) => { app.navigate(`/operators/view/${data.id_operator}`) },
			icon: "pi pi-eye",
			visible: () => auth.canView('operators/view')
		},
		{
			label: "Edit",
			command: (event) => { app.navigate(`/operators/edit/${data.id_operator}`) },
			icon: "pi pi-pencil",
			visible: () => auth.canView('operators/edit')
		},
		{
			label: "Delete",
			command: (event) => { deleteItem(data.id_operator) },
			icon: "pi pi-trash",
			visible: () => auth.canView('operators/delete')
		}
	]
	.filter((item) => {
		if(item.visible){
			return item.visible()
		}
		return true;
	});
		return (<Menubar className="p-0 " model={items} />);
	}
	function PageLoading(){
		if(loading){
			return (
				<>
					<div className="flex align-items-center justify-content-center text-gray-500 p-3">
						<div><ProgressSpinner style={{width:'30px', height:'30px'}} /> </div>
						<div  className="font-bold text-lg">Caricamento in corso...</div>
					</div>
				</>
			);
		}
	}
	function EmptyRecordMessage(){
		if(pageReady && !records.length){
			return (
				<div className="text-lg mt-3 p-3 text-center text-400 font-bold">
					Nessun record trovato
				</div>
			);
		}
	}
	function MultiDelete() {
		if (selectedItems.length) {
			return (
				<div className="m-2 flex-grow-0">
					<Button onClick={() => deleteItem(selectedItems)} icon="pi pi-trash" className="p-button-danger" title="Elimina selezionato"/>
				</div>
			)
		}
	}
	function PagerControl() {
		if (props.paginate && totalPages > 1) {
		const pagerReportTemplate = {
			layout: pagination.layout,
			CurrentPageReport: (options) => {
				return (
					<>
						<span className="text-sm text-gray-500 px-2">Record <b>{ recordsPosition } di { options.totalRecords }</b></span>
					</>
				);
			}
		}
		return (
			<div className="flex-grow-1">
				<Paginator first={firstRow} rows={limit} totalRecords={totalRecords}  onPageChange={onPageChange} template={pagerReportTemplate} />
			</div>
		)
		}
	}
	function PageActionButtons() {
		return (
			<div className="flex flex-wrap">
	<CanView pagePath="operators/delete">
		<MultiDelete />
	</CanView>
			</div>
		);
	}
	function PageFooter() {
		if (pageReady && props.showFooter) {
			return (
				<div className="flex flex-wrap">
					<PageActionButtons />
					<PagerControl />
				</div>
			);
		}
	}
	function PageBreadcrumbs(){
		if(props.showBreadcrumbs) {
			const items = getPageBreadCrumbs();
			return (items.length > 0 && <BreadCrumb className="mb-3" model={items} />);
		}
	}
	if(apiRequestError){
		return (
			<PageRequestError error={apiRequestError} />
		);
	}
	return (
<main id="OperatorsListPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container-fluid">
            <div className="grid justify-content-between align-items-center">
                <div className="col " >
                    <Title title="Operators"   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
                <div className="col-fixed " >
                    <CanView pagePath="">
                        <Link to={`/operators/add`}>
                            <Button label="Aggiungere nuova" icon="pi pi-plus" type="button" className="p-button w-full bg-primary "  />
                            </Link>
                        </CanView>
                    </div>
                    <div className="col-12 md:col-3 " >
                        <span className="p-input-icon-left w-full">
                        <i className="pi pi-search" />
                        <InputText placeholder="Ricerca" className="w-full" value={filters.search.value}  onChange={(e) => setFilterValue('search', e.target.value)} />
                        </span>
                    </div>
                </div>
            </div>
        </section>
        }
        <section className="page-section mb-3" >
            <div className="container-fluid">
                <div className="grid ">
                    <div className="col-sm col md:col-6 comp-grid" >
                        <div className="card  sp-3 mb-3">
                            <DataSource onLoad={(options) => setFilterOptions('status_operator', options)}  apiPath="components_data/status_operator_option_list"  >
                                {
                                ({ response }) => 
                                <>
                                <Title title="Stato"  headerClass="p-3" titleClass="font-bold text-primary" subTitleClass="text-sm text-500"      separator={false} />
                                <div className="">
                                    <MultiSelect className="w-full" optionLabel="label" optionValue="value" value={filters.status_operator.value} onChange={(e) => setFilterValue('status_operator', e.value)} options={filters.status_operator.options} label="" >
                                    </MultiSelect>
                                </div>
                                </>
                                }
                            </DataSource>
                        </div>
                    </div>
                    <div className="col-sm col md:col-6 comp-grid" >
                        <div className="card  sp-3 mb-3">
                            <DataSource onLoad={(options) => setFilterOptions('user_role_id', options)}  apiPath="components_data/user_role_id_option_list_2"  >
                                {
                                ({ response }) => 
                                <>
                                <Title title="Ruolo"  headerClass="p-3" titleClass="font-bold text-primary" subTitleClass="text-sm text-500"      separator={false} />
                                <div className="">
                                    <MultiSelect className="w-full" optionLabel="label" optionValue="value" value={filters.user_role_id.value} onChange={(e) => setFilterValue('user_role_id', e.value)} options={filters.user_role_id.options} label="" >
                                    </MultiSelect>
                                </div>
                                </>
                                }
                            </DataSource>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section className="page-section " >
            <div className="container-fluid">
                <div className="grid ">
                    <div className="col comp-grid" >
                        <FilterTags filterController={filterController} />
                        <div >
                            <PageBreadcrumbs />
                            <div className="page-records">
                                <div className="grid ">
                                    {records.map((data, index)=> 
                                    <div className="col-12 md:col-4" key={index}>
                                        <div className="card card shadow-none p-3 surface-100 ">
                                            {/*PageComponentStart*/}
                                            <div className="flex align-items-center">
                                                <div className=" flex flex-column gap-1">
                                                    <div className="font-bold">Nome</div>
                                                    <div className="font-bold text-500">{ data.name }</div>
                                                </div>
                                            </div>
                                            <hr className="my-2" />
                                            <div className="flex align-items-center">
                                                <div className=" flex flex-column gap-1">
                                                    <div className="font-bold">Cognome</div>
                                                    <div className="font-bold text-500">{ data.surname }</div>
                                                </div>
                                            </div>
                                            <hr className="my-2" />
                                            <div className="flex align-items-center">
                                                <div className=" flex flex-column gap-1">
                                                    <div className="font-bold">Telefono</div>
                                                    <div className="font-bold text-500">
                                                        <a className="p-button-text" href={`tel:${data.telephone}`}>{ data.telephone }</a>
                                                    </div>
                                                </div>
                                            </div>
                                            <hr className="my-2" />
                                            <div className="flex justify-content-end">
                                                {ActionButton(data)}
                                            </div>
                                            {/*PageComponentEnd*/}
                                        </div>
                                    </div>
                                    )}
                                </div>
                            </div>
                            <EmptyRecordMessage />
                            <PageFooter />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
	);
}
OperatorsListPage.defaultProps = {
	primaryKey: 'id_operator',
	pageName: 'operators',
	apiPath: 'operators/index',
	routeName: 'operatorslist',
	msgBeforeDelete: "Sei sicuro di voler cancellare questo record?",
	msgTitle: "Elimina record",
	msgAfterDelete: "Record cancellato con successo",
	showHeader: true,
	showFooter: true,
	paginate: true,
	isSubPage: false,
	showBreadcrumbs: true,
	exportData: false,
	importData: false,
	keepRecords: false,
	multiCheckbox: true,
	search: '',
	fieldName: null,
	fieldValue: null,
	sortField: '',
	sortDir: '',
	pageNo: 1,
	limit: 10,
}
export default OperatorsListPage;
